import { ComponentType, FunctionComponent } from 'react';
import { useHiddenProjects } from 'hooks/useHiddenProjects';

type ProjectProps = {
  project: {
    slug: string;
  };
};

const withProjectVisibility = <T extends ProjectProps>(
  WrappedComponent: ComponentType<T>,
): FunctionComponent<T> => {
  const WithProjectVisibility: FunctionComponent<T> = (props) => {
    const { isProjectHidden } = useHiddenProjects();
    const { project } = props;

    // Check if the project is hidden using the 'slug'
    if (isProjectHidden(project.slug)) {
      return null; // Do not render the component if the project is hidden.
    }

    // Spread props on the wrapped component to pass all given props to it.
    return <WrappedComponent {...props} />;
  };

  return WithProjectVisibility;
};

export default withProjectVisibility;
